// Shows the sitewide sale that is live right now (or the regular price), since a cached page can
// outlive a sale's start or end time. Options are rendered by snippets/sale-prices.liquid, best first.
class SalePrices extends HTMLElement {
  connectedCallback() {
    this.update();
  }

  update() {
    const now = Date.now() / 1000;
    const options = [...this.children];
    const live = options.find((option) => {
      if (option.dataset.starts === undefined) return true;

      const startsAt = Number(option.dataset.starts);
      const endsAt = Number(option.dataset.ends);
      return now >= startsAt && (endsAt === 0 || now < endsAt);
    });

    options.forEach((option) => {
      option.hidden = option !== live;
    });
  }
}

if (!window.customElements.get('sale-prices')) {
  window.customElements.define('sale-prices', SalePrices);
}
